<template>
  <div>
    <CRow>
      <CCol lg="26">
         <CTableWrapper :items="getMessagesData()" 
              newdevicesfilter="() => updatemessagefilterfromdevice()"
         v-on:row-clicked="(item, index) => updateRowSelected( item,index )"          
         >            
          <template #header>
            <CIcon name="cil-grid"/>Messages reçus
            <div class="card-header-actions">
               <CIcon name="cil-cloud-download"/>
              <a 
                :href="getAPI()+'/api1/messages?convpayload=yes&format=csv&direction=MO'"
                class="card-header-action" 
                rel="noreferrer noopener" 
                target="_blank"
              >Messages export (.csv)
              </a>
            </div>
          </template>
        </CTableWrapper>
      </CCol>
    </CRow>
    <CRow>
      <CCol lg="26">
         <CTableWrapperDetail ref="CTableWrapperDetail" :items="getMessagesDetailsData()"
         :sorterValue="{ column: 'time', asc: 'false' }"
          >  
            
          <template #header>
            <CIcon name="cil-grid"/>Details du message 
            <div class="card-header-actions">
           <CIcon name="cil-cloud-download"/>
            <a 
                :href="getAPI()+'/api1/messages?convpayload=yes&format=csv&direction=MO&id='+getMessagesSelectedData()._id"
                class="card-header-action" 
                rel="noreferrer noopener" 
                target="_blank"
              >Details export (.csv)
              </a>
              </div>
          </template>
        </CTableWrapperDetail>
      </CCol>
    </CRow>    
  </div>
</template>

<script>

//require('dotenv').config()
const APIURL = process.env.VUE_APP_API_URL

import CTableWrapper from './SNmessage.vue'
import CTableWrapperDetail from './SNmessageDetail.vue'
import axios from 'axios'

export default {
  name: 'SNMessages',
  data() {
    return { 
      loading: true,
      rowSelected: -1,
      infoSelected: {},
      // holder
      info: [],
      detailsSelected: []
    }
  },   
  components: { 
          CTableWrapper,
          CTableWrapperDetail
  },
  mounted() 
  {
        var addId=""

        // single message?
        if (this.$route.query.id != null)
            addId = "&id="+this.$route.query.id
        
        {          
          // some time the filter is not uptodate => this add the same delay that the header page => ugly but works
          {
            
              axios.get( APIURL+'/api1/devices', {   
                mode: 'no-cors',
                      headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json',
                    },
                  withCredentials: false
                } )
                .then(  res => { 
                  console.log('finally imei ='+res)
                }  )
               .catch( err => console.log(err))
               .finally(() => {
                     console.log('SN messages mounted() imei='+this.$store.state.filterDevicesIMEI)
                      var addIMEI="",addDateFrom="",addDateTo=""
                      if (addId.length<=0)
                      {
                          addIMEI='&imei='+this.$store.state.filterDevicesIMEI
                          console.log('finally imei store='+this.$store.state.filterDevicesIMEI)
                          var d=this.$store.state.filterDateStart
                          addDateFrom='&dateFrom='+(d.getFullYear())+'-'+(d.getMonth()+1)+'-'+(d.getDate())
                          d=this.$store.state.filterDateEnd
                          addDateTo='&dateTo='+(d.getFullYear())+'-'+(d.getMonth()+1)+'-'+(d.getDate())
                      }
                      
                      axios.get( APIURL+'/api1/messages?direction=MO'+addId+addDateFrom+addDateTo+addIMEI, {   
                        mode: 'no-cors',
                              headers: {
                              Accept: 'application/json',
                              'Content-Type': 'application/json',
                            },
                          withCredentials: false
                        } )
                        .then( res => { 
                                this.info = res.data

                                if (this.info != null)
                                for(var i=0; i< this.info.length; i++)
                                {              
                                    var dmsg = this.$SNConvPayload( this.info[i].payload )
                                    if ( (dmsg == null) )//|| (dmsg.length==0) )
                                    {
                                      console.log('SNmessages.mounted(): ERROR this.info['+i+'] dmsg='+dmsg)
                                      this.info[i].status  =  'ERROR'
                                    }
                                    else
                                    {
                                     // console.log('SNmessages.mounted(): OK this.info['+i+'] dmsg='+dmsg)
                                      this.info[i].status =  'OK'
                                      this.info[i].msgTimeRTC  =  dmsg.time
                                      this.info[i].msgTimeGPS  =  dmsg.time  // todo
                                      this.info[i].msgMCUTemp = dmsg.temperature.toFixed(2)
                                      this.info[i].msgMCUBatteries = dmsg.voltage.toFixed(3)
                                      this.info[i].msgLatitude = dmsg.lattitude.toFixed(8)
                                      this.info[i].msgLongitude = dmsg.longitude.toFixed(8)
                                      /*
                                      this.info[0].msgGPSLink = 'https://www.google.com/maps/place/'+
                                          dmsg.lattitude.toString()+","+
                                          dmsg.longitude.toString()+"/@"+ 
                                          dmsg.lattitude.toString()+","+
                                          dmsg.longitude.toString()+",16z";
                                          */
                    

                                      this.info[i].msgGPSLink = '/#/SN/SNLocalisation?lat='+
                                          dmsg.lattitude.toString()+"&lng="+
                                          dmsg.longitude.toString()+"&tok="+parseInt(Date.now())

                                      this.info[i].msgResetNb = dmsg.nbReset
                                      this.info[i].msgSaveNb = dmsg.nbSave
                                      this.info[i].msgRecordingNb = dmsg.nbRecording
                                      this.info[i].msgFWVersion = dmsg.FWversion
                                      this.info[i].msgZoomScale = dmsg.zoomScale
                                      this.info[i].msgDetails = dmsg.details
                                      this.info[i].time = this.$SNFormatDate( this.info[i].time )                                  
                                    }
                                }
                            }  )
                        .catch( err => console.log(err))
                        .finally(() => {
                            this.loading = false
                          }
                        ) 
                } )
          } 
          console.log(' mountedimei='+this.$store.state.filterDevicesIMEI)
       }
  },

  methods: 
  {
    getAPI()
    {
        return(APIURL)
    },
    getMessagesSelectedData()
    {
      console.log('getMessagesDetailsData(): this.infoSelected=', this.infoSelected)
      return this.infoSelected
    },
    updatemessagefilterfromdevice()
    {
        console.log('updatemessagefilterfromdevice='+this.$store.state.filterDevicesIMEI)
    },
    updateRowSelected(item,row )            
    {
      console.log('updateRowSelected(): updateRowSelected=',row)
      if (item.status == 'OK')
      {
        console.log('updateRowSelected(): item.status=',item.status)
        this.rowSelected = row
        this.infoSelected = item
        this.detailsSelected=[]
        for (let index = 0; index < item.msgDetails.length; index++) {
          console.log('updateRowSelected() :', this.detailsSelected[index])
          this.detailsSelected[index]={ time:' ' } 
          this.detailsSelected[index].time=this.$SNFormatDate( item.msgDetails[index][0] )
          this.detailsSelected[index].latitude=item.msgDetails[index][1].toFixed(7)
          this.detailsSelected[index].longitude=item.msgDetails[index][2].toFixed(7)
          this.detailsSelected[index].temperature=item.msgDetails[index][3]
          this.detailsSelected[index].map=item.msgDetails[index][4]        
        }
        console.log('updateRowSelected() :',item)
        console.log('updateRowSelected() :',this.detailsSelected[0])
      }
      else
        console.log('updateRowSelected(): item.status=',item.status)
    },    
    // bind
    getMessagesData() {
      return this.info
    },
    getMessagesDetailsData() {
      return this.detailsSelected 
    }    
  }
}

</script>
